angular.module( 'acme.view.application.membership.offerings.create.lifecycle', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.offerings.create.lifecycle.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipOfferingsCreateLifecycle = {
        name: 'application.membership.offerings.create.lifecycle',
        url: '/lifecycle',
        views: {
          "subview-main": {
            controller: 'MembershipOfferingsCreateLifecycleController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/offerings/create/lifecycle/lifecycle.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipOfferingsCreateLifecycle);
});
